<template>
  <router-view/>
</template>

<script>
export default {
  name: 'User.Dashboard'
}
</script>

<style scoped>

</style>
